module.exports = __webpack_public_path__ + "media/images/front/sp/article/mv-b0defbcb0c28f4386d2bb2ac9fce6d24.png";